import wrenLogo from "../../shared/assets/wren.png";

interface QuickActionsProps {
  partnerName: string;
  chatLink: string;
  groupChatLink: string;
  onInviteClick: () => void;
}

export function QuickActions({ partnerName, chatLink, groupChatLink, onInviteClick }: QuickActionsProps) {
  const partnerJoined = !!groupChatLink;
  const partnerInitial = (partnerName[0] || "?").toUpperCase();

  return (
    <div>
      <h3 className="font-serif text-lg font-medium text-black mb-4">Quick Actions</h3>
      <div className="flex gap-4">
        {/* Text Wren */}
        <a
          href={chatLink || undefined}
          onClick={(e) => {
            if (!chatLink) {
              e.preventDefault();
              onInviteClick();
            }
          }}
          className="flex-1 bg-[#fdfcfa] rounded-2xl p-6 flex flex-col items-center gap-4 shadow-[0px_1px_10px_0px_rgba(0,0,0,0.1)]"
        >
          <div className="w-14 h-14 rounded-full bg-[#2d4739] flex items-center justify-center overflow-hidden">
            <img src={wrenLogo} alt="Wren" className="w-9 h-9 object-contain" />
          </div>
          <span className="text-sm font-medium text-text-primary">Text Wren</span>
        </a>

        {/* Second action: Text Partner (if joined) or Invite Partner */}
        {partnerJoined ? (
          <a
            href={groupChatLink}
            className="flex-1 bg-[#fdfcfa] rounded-2xl p-6 flex flex-col items-center gap-4 shadow-[0px_1px_10px_0px_rgba(0,0,0,0.1)]"
          >
            <div className="w-14 h-14 rounded-full bg-[#c4a47a] flex items-center justify-center">
              <span className="text-white text-xl font-semibold">{partnerInitial}</span>
            </div>
            <span className="text-sm font-medium text-text-primary">Text {partnerName}</span>
          </a>
        ) : (
          <button
            onClick={onInviteClick}
            className="flex-1 bg-[#fdfcfa] rounded-2xl p-6 flex flex-col items-center gap-4 shadow-[0px_1px_10px_0px_rgba(0,0,0,0.1)]"
          >
            <div className="w-14 h-14 rounded-full bg-[#2d4739] flex items-center justify-center">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
                <path d="M22 2L11 13M22 2L15 22L11 13M22 2L2 9L11 13"/>
              </svg>
            </div>
            <span className="text-sm font-medium text-text-primary">Invite {partnerName}</span>
          </button>
        )}
      </div>
    </div>
  );
}
